import {Component, OnInit, Input, Inject, inject, DestroyRef} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { MatDialog } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { InstancesService } from 'src/app/services/api/instances.service';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { DbbackupService } from 'src/app/services/api/dbbackup.service';
@Component({
    selector: 'app-database-backup',
    templateUrl: './database-backup.component.html',
    styleUrls: ['./database-backup.component.scss'],
    standalone: false
})
export class DatabaseBackupComponent  implements OnInit {
  @Input() databases: any;
  @Input() instanceName: any;
  dbForm: FormGroup;
  tenant: string;
  private destroyRef = inject(DestroyRef);

  constructor(private formBuilder: FormBuilder, public sidenavService: SidenavService, private dialog: MatDialog,
  private instancesService: InstancesService, private backupService: DbbackupService, private toastrService: CustomToastrService
  ) {
    
  }

  ngOnInit(): void {
    const formConfig: any = {
      instanceName: [''],
      database: [''],
      createdDate: [''],
      retention: [''],
      createdBy: ['']
    };
    this.dbForm = this.formBuilder.group(formConfig);
  }  

  deleteConfirm(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title:(translate('INSTANCE_DETAILS.DATABASE_BACKUP.DELETE')) + ' ?',
        message:translate('INSTANCE_DETAILS.DATABASE_BACKUP.CONFIRM_MESSAGE'),
        confirmButtonText: translate('DIALOG.SUBMIT')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.backupService.deleteInstanceDbbackup(this.databases.instanceId, this.databases?.id)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((data) => {
              this.sidenavService.closeRightSidenav(true);
            setTimeout(() => {
              const title = translate('TENANT_DETAILS.DATABASE_BACKUP'); 
              const message = translate('INSTANCE_DETAILS.DATABASE_BACKUP.DB_BACKUP_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
          }, (error) => {
              this.sidenavService.closeRightSidenav(false);
              const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                minHeight: '280px',
                width: '630px',
                panelClass: 'flex-dialog',
                data: {
                  title:  translate('ERROR_DIALOG.DELETE_DATABASE_BACKUP'),
                  description: errorMessage
                }
              }); 
          }
          );
        }
      });
  }
}

   

